import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Public certificate verification page. Shown at /cert/:certNumber.
 * No login required — anyone with a cert number can confirm authenticity.
 */
export default function CertVerify() {
  const { certNumber } = useParams();
  const [cert, setCert] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    fetch(`/api/certificates/${encodeURIComponent(certNumber)}/public`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((data) => { setCert(data.certificate); setStatus('found'); })
      .catch(() => setStatus('not_found'));
  }, [certNumber]);

  return (
    <div className="max-w-xl mx-auto px-4 py-16">
      {status === 'loading' && <p className="text-slate-500">Verifying…</p>}
      {status === 'not_found' && (
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600">Certificate not found</h1>
          <p className="mt-2 text-slate-600">No record matches certificate number <code>{certNumber}</code>.</p>
        </div>
      )}
      {status === 'found' && cert && (
        <div className="border-2 border-emerald-500 rounded-lg bg-white p-8 text-center">
          <div className="inline-block px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold uppercase tracking-wide">
            Verified
          </div>
          <h1 className="mt-4 text-2xl font-bold">{cert.course_title_snapshot}</h1>
          <p className="mt-3 text-lg">Awarded to</p>
          <p className="text-2xl font-semibold">{cert.learner_name_snapshot}</p>
          <p className="mt-3 text-sm text-slate-500">
            Issued {new Date(cert.issued_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          {cert.score_snapshot != null && (
            <p className="text-sm text-slate-500">Score: {cert.score_snapshot}%</p>
          )}
          <p className="mt-6 text-xs text-slate-400 font-mono">{cert.certificate_number}</p>
        </div>
      )}
    </div>
  );
}
